import { createSearchParams } from "react-router-dom"

import { PRODUCT } from "shared/constants/permalinks"
import { ProductPosition } from "shared/types/ProductPosition"

export function getProductPositionHref(
  productPosition: ProductPosition | null | undefined
) {
  if (!productPosition) {
    return ""
  }

  const params: Record<string, string> = {}

  if (productPosition.configurationKey) {
    params.configurationKey = productPosition.configurationKey
  }
  if (productPosition.dimensioning?.transactionId) {
    params.dimensioningKey = productPosition.dimensioning?.transactionId
  }

  const path = `${PRODUCT}/${productPosition?.variantKey}`
  const searchParams = createSearchParams(params)
  return searchParams ? `${path}?${searchParams}` : path
}
